(function () {
  const QUIZ_DISCOUNT_CODE = 'TAKEITEASE10';
  const COUPON_AMOUNT_CENTS = 2000;

  function formatMoney(cents, format) {
    if (window.EaseMoney && typeof window.EaseMoney.format === 'function') {
      return window.EaseMoney.format(cents, format);
    }
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format || window.theme?.moneyFormat);
    }
    // No hardcoded euro: EaseMoney knows the shop's format for every market.
    if (window.EaseMoney && typeof window.EaseMoney.renderMoneyFormat === 'function') {
      return window.EaseMoney.renderMoneyFormat(cents, format);
    }
    return (cents / 100).toFixed(2).replace('.', ',');
  }

  function monthlyInstallmentCents(principalCents, aprAnnual, months) {
    if (!principalCents || principalCents <= 0 || !months || months < 1) return 0;
    const principal = principalCents / 100;
    const monthlyRate = aprAnnual / 100 / 12;
    if (monthlyRate <= 0) {
      return Math.ceil(principalCents / months);
    }
    const factor = Math.pow(1 + monthlyRate, months);
    const monthly = (principal * monthlyRate * factor) / (factor - 1);
    return Math.max(1, Math.round(monthly * 100));
  }

  function parseConfig(root) {
    const el =
      root.querySelector('[data-ease-simple-pdp-config]') ||
      root.closest('product-info')?.querySelector('[data-ease-simple-pdp-config]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function hasQuizDone() {
    try {
      for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
        if (key && key.indexOf('ease-nervensystem-quiz:') === 0 && key.endsWith(':done')) {
          return true;
        }
      }
    } catch (e) {
      /* ignore */
    }
    return false;
  }

  function findTierKey(config, variant, fallbackTier) {
    if (!config || !variant || !config.tierValues) return fallbackTier || config.defaultTier || 'premium';
    const tierOptionIndex = config.tierOptionIndex;
    if (tierOptionIndex == null) return fallbackTier || config.defaultTier || 'premium';
    const val = variant.options[tierOptionIndex];
    if (!val) return fallbackTier || config.defaultTier || 'premium';
    const handle = val.toLowerCase();
    const essentialVal = (config.tierValues.essential || '').toLowerCase();
    const premiumVal = (config.tierValues.premium || '').toLowerCase();

    if (essentialVal && handle === essentialVal) return 'essential';
    if (premiumVal && handle === premiumVal) return 'premium';
    if (
      handle.includes('essential') ||
      handle.includes('einstieg') ||
      handle.includes('12 monat') ||
      handle.includes('30 tag')
    ) {
      return 'essential';
    }
    if (handle.includes('premium') || handle.includes('lifetime')) {
      return 'premium';
    }
    return fallbackTier || config.defaultTier || 'premium';
  }

  function variantForTierAndColor(config, tierKey, selectedOptions) {
    if (!config || !config.variants) return null;
    const tierOptionIndex = config.tierOptionIndex;
    const tierVal = config.tierValues && config.tierValues[tierKey];
    return config.variants.find((v) => {
      if (!v.available && config.requireAvailable) return false;
      if (tierOptionIndex != null && tierVal && v.options[tierOptionIndex] !== tierVal) return false;
      if (config.colorOptionIndex != null && selectedOptions) {
        const colorVal = selectedOptions[config.colorOptionIndex];
        if (colorVal && v.options[config.colorOptionIndex] !== colorVal) return false;
      }
      return true;
    });
  }

  function formatPreorderRestockDate(restockDate, locale) {
    if (!restockDate) return '';
    const parts = String(restockDate).trim().split('-').map((n) => parseInt(n, 10));
    if (parts.length !== 3 || parts.some((n) => Number.isNaN(n))) return String(restockDate);
    const date = new Date(parts[0], parts[1] - 1, parts[2], 12, 0, 0);
    const lang = (locale || document.documentElement.lang || 'de').toLowerCase();
    try {
      if (lang.startsWith('en')) {
        return new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short' }).format(date);
      }
      return new Intl.DateTimeFormat('de-DE', { day: 'numeric', month: 'long' }).format(date);
    } catch (e) {
      return `${parts[2]}.${String(parts[1]).padStart(2, '0')}.`;
    }
  }

  function formatPreorderRestockLabel(config) {
    const template = config.preorderRestockLine || 'nächste Auflage · Versand ab __DATE__';
    const dateLabel = formatPreorderRestockDate(config.preorderRestockDate, config.dateLocale);
    return template.replace(/__DATE__/g, dateLabel);
  }

  function isVariantPreorder(variant, config) {
    if (!config?.preorderEnabled || !variant) return false;

    const stockMap = config.variantInventory || {};
    const meta = stockMap[String(variant.id)] || stockMap[variant.id];
    if (meta) {
      if (meta.tracked === false) return false;
      if (meta.policy !== 'continue') return false;
      return typeof meta.qty === 'number' ? meta.qty <= 0 : false;
    }

    // Fallback without inventory map: only preorder when continue-selling is on and stock is gone.
    if (variant.inventory_policy !== 'continue') return false;
    if (variant.inventory_management && typeof variant.inventory_quantity === 'number') {
      return variant.inventory_quantity <= 0;
    }
    return variant.available === false;
  }

  function isStickyDrawerOpen() {
    if (!document.body.classList.contains('ease-sticky-drawer-open')) return false;
    const drawer = document.querySelector('.ease-sticky-atc-drawer, modal-component.ease-sticky-atc-drawer');
    if (!drawer) return false;
    return drawer.hasAttribute('open') || drawer.hasAttribute('active') || drawer.open === true;
  }

  function reconcileStickyDrawerBodyClass() {
    if (isStickyDrawerOpen()) return;
    if (!document.body.classList.contains('ease-sticky-drawer-open')) return;
    document.body.classList.remove('ease-sticky-drawer-open');
    document.body.style.removeProperty('--ease-sticky-drawer-scroll-y');
  }

  function resolveVariantFromDom(root, config) {
    if (!config?.variants?.length) return null;
    const variantSelects = root.querySelector('variant-selects');
    if (!variantSelects) return null;

    const selectedByIndex = {};
    variantSelects.querySelectorAll('fieldset.product-form__input').forEach((fieldset, index) => {
      const checked = fieldset.querySelector('input[type="radio"]:checked, select option[selected]');
      if (!checked) return;
      selectedByIndex[index] = checked.value;
    });

    return (
      config.variants.find((candidate) => {
        if (!candidate?.options?.length) return false;
        return candidate.options.every((optionValue, index) => {
          const selected = selectedByIndex[index];
          return selected == null || selected === optionValue;
        });
      }) || null
    );
  }

  function ensureDrawerFlushListener() {
    if (ensureDrawerFlushListener.bound) return;
    ensureDrawerFlushListener.bound = true;
    document.addEventListener('ease-sticky-drawer-closed', () => {
      document.querySelectorAll('[data-ease-simple-pdp]').forEach((section) => {
        if (typeof section.__easeSimplePdpFlush === 'function') {
          section.__easeSimplePdpFlush();
        }
      });
    });
  }

  function initSection(section) {
    const root = section.closest('product-info') || section;
    const config = parseConfig(section) || parseConfig(root);
    if (!config) return;

    const state = {
      tier: config.defaultTier || 'premium',
      coupon: false,
      quizAvailable: hasQuizDone(),
    };
    let optionChangeFromColor = false;
    let preserveTierUntil = 0;
    let explicitTierUntil = 0;

    const els = {
      tierLabel: root.querySelector('[data-ease-tier-label]'),
      tierEssential: root.querySelector('[data-ease-tier="essential"]'),
      tierPremium: root.querySelector('[data-ease-tier="premium"]'),
      priceNow: root.querySelector('[data-ease-price-now]'),
      priceCompare: root.querySelector('[data-ease-price-compare]'),
      valueHint: root.querySelector('[data-ease-value-hint]'),
      roadFoot: root.querySelector('[data-ease-road-foot]'),
      couponBox: root.querySelector('[data-ease-coupon-box]'),
      couponToggle: root.querySelector('[data-ease-coupon-toggle]'),
      couponHint: root.querySelector('[data-ease-coupon-hint]'),
      cta: root.querySelector('[data-ease-cta]'),
      ctaLabel: root.querySelector('[data-ease-cta-label]'),
      klarnaAmount: root.querySelector('[data-ease-klarna-amount]'),
      variantInput: root.querySelector('.product-variant-id'),
      form: root.querySelector('[data-ease-simple-pdp-form]'),
      tierProperty: root.querySelector('[data-ease-tier-property]'),
      deliveryEstimate: root.querySelector('[data-ease-delivery-estimate]'),
      deliveryStock: root.querySelector('[data-ease-delivery-stock]'),
      deliveryRest: root.querySelector('[data-ease-delivery-rest]'),
      deliveryPreorder: root.querySelector('[data-ease-delivery-preorder]'),
    };

    function syncPreorderUi(variant) {
      if (!config.preorderEnabled) return;
      const restockLabel = formatPreorderRestockLabel(config);
      const selectedIsPreorder = isVariantPreorder(variant, config);

      if (els.deliveryStock) {
        els.deliveryStock.textContent = selectedIsPreorder
          ? `● ${config.preorderStockLabel || config.preorderBadge || 'Ausverkauft'}`
          : `● ${config.stockLabel || 'Auf Lager'}`;
      }
      if (els.deliveryRest) {
        els.deliveryRest.hidden = selectedIsPreorder;
      }
      if (els.deliveryPreorder) {
        els.deliveryPreorder.hidden = !selectedIsPreorder;
        if (selectedIsPreorder) {
          els.deliveryPreorder.innerHTML = ` · <b>${restockLabel}</b>`;
        }
      }
      if (els.deliveryEstimate) {
        els.deliveryEstimate.classList.toggle('is-preorder', selectedIsPreorder);
        const stockLabel = selectedIsPreorder
          ? config.preorderStockLabel || config.preorderBadge || 'Ausverkauft'
          : config.stockLabel || 'Auf Lager';
        if (selectedIsPreorder) {
          els.deliveryEstimate.setAttribute('aria-label', `${stockLabel} · ${restockLabel}`);
        }
      }
    }

    // Gesamtersparnis gegen den Vergleichspreis der Variante. Gerechnet wird gegen
    // den tatsaechlich angezeigten Preis, ein aktiver Coupon zaehlt also mit.
    // Beide Betraege laufen durch denselben Formatter wie der Button, damit die
    // Waehrung im CH-Market nicht zwischen den Zeilen springt.
    function savingsForVariant(variant, priceCents) {
      const resolved = resolveVariantForDisplay(variant);
      const compare = resolved && resolved.compare_at_price;
      if (!compare || !priceCents || compare <= priceCents) return null;
      return {
        compare: formatMoney(compare, config.moneyFormat),
        saved: formatMoney(compare - priceCents, config.moneyFormat),
      };
    }

    function ctaLabelForVariant(variant, priceCents) {
      const isPreorder = isVariantPreorder(variant, config);
      const label = isPreorder
        ? config.preorderCtaLabel || 'Nächste Auflage sichern'
        : config.ctaLabel || 'In den Warenkorb';
      if (!variant) return label;
      return `${label} · ${formatMoney(priceCents, config.moneyFormat)}`;
    }

    function syncTierProperty() {
      if (!els.tierProperty) return;
      els.tierProperty.value = state.tier || config.defaultTier || 'premium';
    }

    function getSelectedVariant() {
      const jsonEl = root.querySelector('[data-selected-variant]');
      if (!jsonEl) return null;
      try {
        return JSON.parse(jsonEl.textContent);
      } catch (e) {
        return null;
      }
    }

    function syncTierRadioToState() {
      if (config.tierOptionIndex == null) return;
      const tierVal = config.tierValues && config.tierValues[state.tier];
      if (!tierVal) return;
      const radio = findTierRadio(tierVal);
      if (radio && !radio.checked) {
        radio.checked = true;
      }
    }

    function syncColorRadioFromVariant(variant) {
      if (!variant?.options || config.colorOptionIndex == null) return;
      const colorVal = variant.options[config.colorOptionIndex];
      if (!colorVal) return;
      const colorFieldset = root.querySelector('.product-form__input--color');
      if (!colorFieldset) return;
      const radio = Array.from(colorFieldset.querySelectorAll('input[type="radio"]')).find(
        (input) => input.value === colorVal
      );
      if (!radio || radio.checked) return;
      radio.checked = true;
      const variantSelects = root.querySelector('variant-selects');
      if (variantSelects && typeof variantSelects.updateSelectedSwatchValue === 'function') {
        variantSelects.updateSelectedSwatchValue({ target: radio });
      }
    }

    function shouldPreserveTierSelection() {
      return optionChangeFromColor || Date.now() < preserveTierUntil;
    }

    function shouldPreserveExplicitTier() {
      return Date.now() < explicitTierUntil;
    }

    function resolveVariantForDisplay(variant) {
      if (!variant) return null;
      if (config.tierOptionIndex == null) return variant;
      const matched = variantForTierAndColor(config, state.tier, variant.options);
      return matched || variant;
    }

    function markOptionChangeTarget(target) {
      const fromColor = !!(target && target.closest && target.closest('.product-form__input--color'));
      optionChangeFromColor = fromColor;
      if (fromColor) {
        preserveTierUntil = Date.now() + 600;
      }
    }

    function getTierMeta(key) {
      return (config.tiers && config.tiers[key]) || {};
    }

    function couponAllowed() {
      if (config.couponMode !== 'quiz') return false;
      return state.tier === 'premium';
    }

    function syncCouponForTier() {
      if (config.couponMode !== 'quiz') {
        state.coupon = false;
        return;
      }
      state.coupon = state.tier === 'premium';
    }

    function getTierSpreadCents() {
      if (typeof config.tierSpreadCents === 'number' && config.tierSpreadCents >= 0) {
        return config.tierSpreadCents;
      }
      const essentialMeta = getTierMeta('essential');
      const premiumMeta = getTierMeta('premium');
      return Math.max(0, (premiumMeta.fallbackPriceCents || 0) - (essentialMeta.fallbackPriceCents || 0));
    }

    function propertyTierPriceCents(tierKey, variant) {
      if (!variant) {
        const tierMeta = getTierMeta(tierKey);
        return tierMeta.fallbackPriceCents || 0;
      }
      const spread = getTierSpreadCents();
      const premiumCents = variant.price;
      const essentialCents = Math.max(0, premiumCents - spread);
      return tierKey === 'essential' ? essentialCents : premiumCents;
    }

    function propertyTierCompareCents(variant, priceCents) {
      const compareAt =
        variant && typeof variant.compare_at_price === 'number' ? variant.compare_at_price : 0;
      return compareAt > priceCents ? compareAt : 0;
    }

    function displayPriceCents(variant) {
      const resolvedVariant = resolveVariantForDisplay(variant);
      let cents = 0;
      if (config.tierOptionIndex == null) {
        cents = propertyTierPriceCents(state.tier, resolvedVariant);
      } else if (!resolvedVariant) {
        return 0;
      } else {
        cents = resolvedVariant.price;
      }
      if (state.coupon && couponAllowed()) {
        cents = Math.max(0, cents - COUPON_AMOUNT_CENTS);
      }
      return cents;
    }

    // The price is re-rendered by JS while the package value came straight from
    // Liquid, which formatted the currency differently. Run both through the
    // same formatter so the symbol does not jump between the two lines.
    function updateTierAnchors(root, config) {
      root.querySelectorAll('[data-ease-tier-anchor]').forEach((el) => {
        const cents = parseInt(el.getAttribute('data-cents'), 10);
        if (!Number.isFinite(cents) || cents <= 0) return;
        el.textContent = formatMoney(cents, config.moneyFormat);
      });
    }

    function updateTierCardPrices(root, config) {
      const variant = getSelectedVariant();
      if (!variant) return;
      const moneyFormat = config.moneyFormat;
      const showCompareAt = config.showCompareAt === true;
      const showSaleBadge = config.showSaleBadge === true;
      const badgeLine = showSaleBadge && config.saleBadgeLine ? config.saleBadgeLine : '';
      const propertyTierMode = config.tierOptionIndex == null;

      ['essential', 'premium'].forEach((tierKey) => {
        const tierMeta = getTierMeta(tierKey);
        let priceCents = 0;
        let compareCents = 0;

        if (propertyTierMode) {
          priceCents = propertyTierPriceCents(tierKey, variant);
          compareCents = propertyTierCompareCents(variant, priceCents);
        } else if (variant.options) {
          const tierVariant = variantForTierAndColor(config, tierKey, variant.options);
          if (!tierVariant) return;
          priceCents = tierVariant.price;
          compareCents =
            typeof tierVariant.compare_at_price === 'number' ? tierVariant.compare_at_price : 0;
        } else {
          return;
        }

        const priceEl = root.querySelector(`[data-ease-tier-price="${tierKey}"]`);
        const compareEl = root.querySelector(`[data-ease-tier-compare="${tierKey}"]`);
        const savingEl = root.querySelector(`[data-ease-tier-saving="${tierKey}"]`);
        const showCompare = showCompareAt && compareCents > priceCents;

        // Gesamtwert ist Preis plus Boni. Liquid hat ihn einmal mit dem Basispreis
        // gebildet; wechselt der Gast auf eine teurere Farbe, muss er mitwandern.
        // Sonst passt er nicht mehr zur Ersparnis darunter, die als Boni-Summe
        // konstant bleibt: 339 statt 349 liess "du sparst 150" um 10 danebenliegen.
        const anchorEl = root.querySelector(`[data-ease-tier-anchor="${tierKey}"]`);
        if (anchorEl && priceCents > 0) {
          const stackCents = parseInt(anchorEl.getAttribute('data-stack-cents'), 10);
          if (Number.isFinite(stackCents) && stackCents > 0) {
            anchorEl.setAttribute('data-cents', String(stackCents + priceCents));
          }
        }

        if (priceEl) priceEl.textContent = formatMoney(priceCents, moneyFormat);
        if (compareEl) {
          compareEl.hidden = !showCompare;
          if (showCompare) compareEl.textContent = formatMoney(compareCents, moneyFormat);
        }
        if (savingEl) {
          const showBadge = showCompare && showSaleBadge && badgeLine;
          savingEl.hidden = !showBadge;
          if (showBadge) savingEl.textContent = badgeLine;
        }
      });
    }

    function renderMinimalForDrawer() {
      const variant = getSelectedVariant();
      const priceCents = displayPriceCents(variant);
      const moneyFormat = config.moneyFormat;

      if (els.tierEssential) {
        const essentialOn = state.tier === 'essential';
        els.tierEssential.classList.toggle('is-active', essentialOn);
        els.tierEssential.setAttribute('aria-pressed', essentialOn ? 'true' : 'false');
      }
      if (els.tierPremium) {
        const premiumOn = state.tier === 'premium';
        els.tierPremium.classList.toggle('is-active', premiumOn);
        els.tierPremium.setAttribute('aria-pressed', premiumOn ? 'true' : 'false');
      }
      updateTierCardPrices(root, config);
      updateTierAnchors(root, config);

      if (els.ctaLabel && variant) {
        els.ctaLabel.textContent = ctaLabelForVariant(variant, priceCents);
      } else if (els.ctaLabel) {
        els.ctaLabel.textContent = config.ctaLabel || 'In den Warenkorb';
      }
      if (els.cta) {
        els.cta.disabled = !variant || !variant.available;
      }

      syncPreorderUi(variant);
      syncTierProperty();
      syncTierRadioToState();
    }

    function render() {
      reconcileStickyDrawerBodyClass();

      if (isStickyDrawerOpen()) {
        renderMinimalForDrawer();
        return;
      }

      const variant = getSelectedVariant();
      const tierMeta = getTierMeta(state.tier);
      const priceCents = displayPriceCents(variant);
      const moneyFormat = config.moneyFormat;

      if (els.tierEssential) {
        const essentialOn = state.tier === 'essential';
        els.tierEssential.classList.toggle('is-active', essentialOn);
        els.tierEssential.setAttribute('aria-pressed', essentialOn ? 'true' : 'false');
      }
      if (els.tierPremium) {
        const premiumOn = state.tier === 'premium';
        els.tierPremium.classList.toggle('is-active', premiumOn);
        els.tierPremium.setAttribute('aria-pressed', premiumOn ? 'true' : 'false');
      }
      if (els.tierLabel && tierMeta.label) {
        els.tierLabel.textContent = tierMeta.label;
      }
      if (els.priceNow) {
        els.priceNow.textContent = formatMoney(priceCents, moneyFormat);
      }
      if (els.priceCompare) {
        const showCompareAt = config.showCompareAt === true;
        if (!showCompareAt) {
          els.priceCompare.hidden = true;
        } else {
          let compareCents = 0;
          if (config.tierOptionIndex == null && variant) {
            compareCents = propertyTierCompareCents(variant, priceCents);
          } else if (variant && typeof variant.compare_at_price === 'number') {
            compareCents = variant.compare_at_price;
          }
          const shouldShowCompare = compareCents > priceCents;
          if (shouldShowCompare) {
            els.priceCompare.hidden = false;
            els.priceCompare.textContent = formatMoney(compareCents, moneyFormat);
          } else {
            els.priceCompare.hidden = true;
          }
        }
      }
      updateTierCardPrices(root, config);
      updateTierAnchors(root, config);
      if (els.valueHint) {
        const hint = (tierMeta.hint || '').trim();
        if (hint) {
          els.valueHint.hidden = false;
          els.valueHint.innerHTML = hint;
        } else {
          els.valueHint.hidden = true;
          els.valueHint.innerHTML = '';
        }
      }
      if (els.roadFoot && tierMeta.roadFoot) {
        els.roadFoot.innerHTML = tierMeta.roadFoot;
      }

      const couponOn = couponAllowed();
      if (els.couponBox) {
        els.couponBox.hidden = state.tier === 'essential';
        if (state.tier !== 'essential') {
          els.couponBox.classList.toggle('is-off', !couponOn);
          els.couponBox.classList.toggle('is-active', state.coupon && couponOn);
        }
      }
      if (els.couponToggle) {
        els.couponToggle.disabled = !couponOn;
        els.couponToggle.classList.toggle('is-on', state.coupon && couponOn);
        els.couponToggle.setAttribute('aria-pressed', state.coupon && couponOn ? 'true' : 'false');
      }
      if (els.couponHint) {
        els.couponHint.textContent =
          state.coupon && couponOn
            ? config.couponActiveNote || 'Quiz-Coupon aktiv.'
            : couponOn
              ? config.couponHintPremium || 'Aus deinem Nervensystem-Check. Nur auf Premium einlösbar.'
              : config.couponHintEssential || 'Für Essential nicht verfügbar – gilt nur für Premium.';
      }

      if (els.ctaLabel && variant) {
        els.ctaLabel.textContent = ctaLabelForVariant(variant, priceCents);
      } else if (els.ctaLabel) {
        els.ctaLabel.textContent = config.ctaLabel || 'In den Warenkorb';
      }
      if (els.cta) {
        els.cta.disabled = !variant || !variant.available;
      }

      if (els.klarnaAmount && config.showKlarnaBadge) {
        const months = config.klarnaMonths || 12;
        const apr = parseFloat(String(config.klarnaApr).replace(',', '.')) || 13.27;
        const installment = monthlyInstallmentCents(priceCents, apr, months);
        els.klarnaAmount.textContent = formatMoney(installment, moneyFormat);
      }

      syncPreorderUi(variant);
      syncColorThumbs(state.tier);
      syncTierProperty();
      syncTierRadioToState();
    }

    function syncColorThumbs(tierKey) {
      const dataKey = tierKey === 'essential' ? 'easeThumbEssential' : 'easeThumbPremium';
      root.querySelectorAll('.ease-variant-card__thumb').forEach((wrap) => {
        const url = wrap.dataset[dataKey];
        if (!url) return;
        const img = wrap.querySelector('img');
        if (img) img.src = url;
      });
    }

    function findTierRadio(tierVal) {
      if (!tierVal) return null;
      const variantSelects = root.querySelector('variant-selects');
      if (!variantSelects) return null;

      const selectors = [];
      if (config.tierRadioName) {
        selectors.push(
          `input[type="radio"][name="${CSS.escape(config.tierRadioName)}"][value="${CSS.escape(tierVal)}"]`
        );
      }
      if (config.tierOptionName) {
        selectors.push(
          `input[type="radio"][name="options[${CSS.escape(config.tierOptionName)}]"][value="${CSS.escape(tierVal)}"]`
        );
        selectors.push(
          `input[type="radio"][name^="${CSS.escape(config.tierOptionName)}"][value="${CSS.escape(tierVal)}"]`
        );
      }

      for (const selector of selectors) {
        const radio = variantSelects.querySelector(selector);
        if (radio) return radio;
      }

      const fieldsets = variantSelects.querySelectorAll('fieldset.product-form__input:not(.product-form__input--color)');
      for (const fieldset of fieldsets) {
        const radio = fieldset.querySelector(`input[type="radio"][value="${CSS.escape(tierVal)}"]`);
        if (radio) return radio;
      }

      return null;
    }

    function selectTier(tierKey) {
      optionChangeFromColor = false;
      preserveTierUntil = 0;
      explicitTierUntil = Date.now() + 900;
      const prevTier = state.tier;
      state.tier = tierKey;
      syncCouponForTier();

      const tierVal = config.tierValues && config.tierValues[tierKey];
      if (tierVal != null && config.tierOptionIndex != null) {
        const radio = findTierRadio(tierVal);
        if (radio) {
          const wasChecked = radio.checked;
          if (!wasChecked) {
            radio.checked = true;
          }
          render();
          if (prevTier !== tierKey || !wasChecked) {
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
          return;
        }
      }

      syncTierRadioToState();
      render();
    }

    function bindTierSelect(el, tierKey) {
      if (!el) return;
      el.addEventListener('click', (event) => {
        if (event.target.closest('[data-ease-members-info]')) return;
        selectTier(tierKey);
      });
      el.addEventListener('keydown', (event) => {
        if (event.target.closest('[data-ease-members-info]')) return;
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        selectTier(tierKey);
      });
    }

    bindTierSelect(els.tierEssential, 'essential');
    bindTierSelect(els.tierPremium, 'premium');

    const membersDialog = root.querySelector('[data-ease-members-dialog]');
    const openMembersDialog = () => {
      if (!membersDialog || typeof membersDialog.showModal !== 'function') return;
      if (membersDialog.open) return;
      membersDialog.showModal();
    };
    const closeMembersDialog = () => {
      if (!membersDialog || !membersDialog.open) return;
      membersDialog.close();
    };

    root.querySelectorAll('[data-ease-members-info]').forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        openMembersDialog();
      });
    });

    root.querySelectorAll('[data-ease-members-dialog-close]').forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        closeMembersDialog();
      });
    });

    if (membersDialog) {
      membersDialog.addEventListener('click', (event) => {
        if (event.target === membersDialog) closeMembersDialog();
      });
    }

    if (els.couponToggle) {
      els.couponToggle.addEventListener('click', () => {
        if (!couponAllowed()) return;
        state.coupon = !state.coupon;
        render();
      });
    }

    function copyTextFallback(text) {
      const field = document.createElement('textarea');
      field.value = text;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      try {
        document.execCommand('copy');
      } catch (e) {
        /* ignore */
      }
      document.body.removeChild(field);
    }

    async function handleCouponCopy(btn) {
      const code = btn.getAttribute('data-coupon-code') || '';
      const copiedLabel = btn.getAttribute('data-coupon-copied-label') || 'Copied!';
      const defaultLabel = btn.getAttribute('data-coupon-default-label') || code;
      const labelNode = btn.querySelector('[data-ease-coupon-copy-label]');
      if (!code) return;

      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(code);
        } else {
          copyTextFallback(code);
        }
      } catch (err) {
        copyTextFallback(code);
      }

      btn.classList.add('is-copied');
      if (labelNode) labelNode.textContent = copiedLabel;
      window.setTimeout(() => {
        btn.classList.remove('is-copied');
        if (labelNode) labelNode.textContent = defaultLabel;
      }, 1800);
    }

    root.addEventListener('click', (event) => {
      const copyBtn = event.target.closest('[data-ease-coupon-copy]');
      if (!copyBtn || !root.contains(copyBtn)) return;
      handleCouponCopy(copyBtn);
    });

    if (els.form) {
      els.form.addEventListener('submit', () => {
        syncTierProperty();
      });
    }

    if (els.form && config.couponMode === 'quiz') {
      els.form.addEventListener('submit', (e) => {
        if (!state.coupon || !couponAllowed()) return;
        e.preventDefault();
        const variant = getSelectedVariant();
        if (!variant) return;

        syncTierProperty();
        const addUrl = `${window.Shopify?.routes?.root || '/'}cart/add.js`;
        const item = { id: variant.id, quantity: 1 };
        if (els.tierProperty) {
          item.properties = { _ease_tier: els.tierProperty.value };
        }
        const body = JSON.stringify({ items: [item] });

        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body,
        })
          .then((res) => {
            if (!res.ok) throw new Error('add failed');
            const redirect = encodeURIComponent('/cart');
            window.location.href = `/discount/${QUIZ_DISCOUNT_CODE}?redirect=${redirect}`;
          })
          .catch(() => {
            els.form.submit();
          });
      });
    }

    const productInfo = root;
    const sectionId = productInfo.dataset.section || section.getAttribute('data-section-id');

    const onVariantChange = (variantFromEvent) => {
      let variant = variantFromEvent || getSelectedVariant();
      if (!variant) {
        variant = resolveVariantFromDom(root, config);
        if (variant) {
          const jsonEl = root.querySelector('variant-selects script[data-selected-variant]');
          if (jsonEl) jsonEl.textContent = JSON.stringify(variant);
          if (els.variantInput && variant.id) {
            els.variantInput.value = variant.id;
            els.variantInput.disabled = !variant.available;
          }
        }
      }
      if (
        variant &&
        config.tierOptionIndex != null &&
        !shouldPreserveTierSelection() &&
        !shouldPreserveExplicitTier()
      ) {
        state.tier = findTierKey(config, variant, state.tier);
      }
      if (variant && shouldPreserveTierSelection()) {
        syncColorRadioFromVariant(variant);
      }
      syncCouponForTier();
      syncTierRadioToState();
      render();
      optionChangeFromColor = false;
    };

    root.addEventListener(
      'change',
      (event) => {
        if (!root.contains(event.target)) return;
        if (!event.target.matches('input[type="radio"], select')) return;
        if (event.target.closest('.product-form__input--color')) {
          optionChangeFromColor = true;
          preserveTierUntil = Date.now() + 600;
          syncTierRadioToState();
        } else if (event.target.closest('variant-selects')) {
          optionChangeFromColor = false;
          preserveTierUntil = 0;
        }
      },
      true
    );

    if (window.FoxTheme && FoxTheme.pubsub) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (payload) => {
        if (!payload || !payload.data) return;
        if (sectionId && payload.data.sectionId && String(payload.data.sectionId) !== String(sectionId)) return;

        markOptionChangeTarget(payload.data.event?.target);

        const jsonEl = root.querySelector('variant-selects script[data-selected-variant]');
        if (jsonEl && payload.data.variant) {
          jsonEl.textContent = JSON.stringify(payload.data.variant);
        }
        onVariantChange(payload.data.variant);
      });
    }

    document.addEventListener('variant:changed', (e) => {
      if (!productInfo || !productInfo.contains(section)) return;
      onVariantChange(e.detail && e.detail.variant);
    });

    document.addEventListener('change', (e) => {
      if (!root.contains(e.target)) return;
      if (e.target.matches('input[type="radio"]') || e.target.matches('select')) {
        markOptionChangeTarget(e.target);
        if (optionChangeFromColor) {
          syncTierRadioToState();
        }
      }
    });

    syncCouponForTier();

    // Prefer Premium on first load. Shopify's selected_or_first_available_variant
    // is often Essential (first in the catalog), which would otherwise steal the active tier.
    // Respect an explicit ?variant= deep-link.
    const urlHasVariant = /(?:^\?|&)variant=/.test(window.location.search || '');
    if (!urlHasVariant) {
      selectTier(config.defaultTier || 'premium');
    } else {
      syncTierRadioToState();
      onVariantChange();
    }

    ensureDrawerFlushListener();
    section.__easeSelectTier = (tierKey) => selectTier(tierKey);
    section.__easeSimplePdpFlush = () => render();
    section.__easeSimplePdpGetCtaLabel = () => {
      const variant = getSelectedVariant();
      const priceCents = displayPriceCents(variant);
      return ctaLabelForVariant(variant, priceCents);
    };
    section.__easeSimplePdpGetSavings = () => {
      const variant = getSelectedVariant();
      return savingsForVariant(variant, displayPriceCents(variant));
    };
  }

  function pad2(n) {
    return n < 10 ? '0' + n : String(n);
  }

  // Resets every local midnight: "Launch-Phase" urgency without a fixed end date.
  function msUntilLocalMidnight(now) {
    const end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
    return Math.max(0, end.getTime() - now.getTime());
  }

  function tickDailyCountdowns() {
    const nodes = document.querySelectorAll('[data-ease-daily-countdown]');
    if (!nodes.length) return;
    const now = new Date();
    const ms = msUntilLocalMidnight(now);
    const totalSec = Math.floor(ms / 1000);
    const h = Math.floor(totalSec / 3600);
    const m = Math.floor((totalSec % 3600) / 60);
    const s = totalSec % 60;
    const hStr = pad2(h);
    const mStr = pad2(m);
    const sStr = pad2(s);
    const end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);

    nodes.forEach((el) => {
      const hEl = el.querySelector('[data-h]');
      const mEl = el.querySelector('[data-m]');
      const sEl = el.querySelector('[data-s]');
      if (hEl) hEl.textContent = hStr;
      if (mEl) mEl.textContent = mStr;
      if (sEl) sEl.textContent = sStr;
      el.setAttribute('datetime', end.toISOString());
    });
  }

  function initDailyCountdowns() {
    if (!document.querySelector('[data-ease-daily-countdown]')) return;
    tickDailyCountdowns();
    if (!window.__easeDailyCountdownTimer) {
      window.__easeDailyCountdownTimer = setInterval(tickDailyCountdowns, 1000);
    }
  }

  function scrollTargetToCenter(target) {
    if (!target) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const rect = target.getBoundingClientRect();
    const absoluteTop = rect.top + window.scrollY;
    const centerOffset = Math.max(0, (window.innerHeight - rect.height) / 2);
    window.scrollTo({
      top: absoluteTop - centerOffset,
      behavior: reduceMotion ? 'auto' : 'smooth',
    });
  }

  function initScrollCenterLinks() {
    document.querySelectorAll('[data-ease-scroll-center]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const selector = link.getAttribute('data-ease-scroll-center') || link.getAttribute('href');
        if (!selector || selector.charAt(0) !== '#') return;
        const target = document.querySelector(selector);
        if (!target) return;
        event.preventDefault();
        scrollTargetToCenter(target);
        if (history.replaceState) {
          history.replaceState(null, '', selector);
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-ease-simple-pdp]').forEach(initSection);
    initDailyCountdowns();
    initScrollCenterLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
